"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralDepositFunnelState = exports.Badge = void 0;
var Badge;
(function (Badge) {
    Badge["BRONZE"] = "BRONZE";
    Badge["SILVER"] = "SILVER";
    Badge["GOLD"] = "GOLD";
})(Badge || (exports.Badge = Badge = {}));
var ReferralDepositFunnelState;
(function (ReferralDepositFunnelState) {
    // 1. User has not started the funnel - and we're resetting their state bit
    ReferralDepositFunnelState["PLAID_CONNECT_NULL_STATE"] = "PLAID_CONNECT_NULL_STATE";
    // 2. User has started the funnel - and we're waiting for them to connect their account
    ReferralDepositFunnelState["PLAID_CONNECT_STARTED"] = "PLAID_CONNECT_STARTED";
    // 3. User has connected their account - and we're waiting for the account to be verified
    ReferralDepositFunnelState["PLAID_CONNECTED_SUCCESS"] = "PLAID_CONNECTED_SUCCESS";
    // 4. User has connected their account - and they failed during the process
    ReferralDepositFunnelState["PLAID_CONNECTED_FAILURE"] = "PLAID_CONNECTED_FAILURE";
    // 5. User has connected their account from before.
    ReferralDepositFunnelState["PLAID_CONNECTED_SUCCESS_WITH_ACCOUNTS"] = "PLAID_CONNECTED_SUCCESS_WITH_ACCOUNTS";
})(ReferralDepositFunnelState || (exports.ReferralDepositFunnelState = ReferralDepositFunnelState = {}));
